import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import { ListMedicalDataResponse, PermissionBit } from "../../../api";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export type MedDataItem = ListMedicalDataResponse["medical_data"][number];

export class MedData<T extends MedDataItem = MedDataItem> extends DataModel<T> {
  readonly idAttr = "uuid" as keyof T;

  // constants
  notEditable = [
    "ePVS",
    "CKD-EPI",
    "CHA2DS2-VA",
    "BMI",
    "BSA",
    "congestion score",
  ];

  constructor(data: T[], permissions?: PermissionBit[], userUUID?: string) {
    super(data, permissions, userUUID);
    this.hasHistory = true;

    // access
    this.access = {
      editRules: {
        medical: AccessRules.owner,
        monitoring: AccessRules.visible,
      },
      deleteRules: {
        medical: AccessRules.none,
        monitoring: AccessRules.visible,
      },
      historyRequiresMonitoring: true,
    };
  }

  override validateItemEdit(item: any): string | undefined {
    if (this.notEditable.includes(item.measurement_type)) {
      return i18n._(msg`Auto-computed`);
    }

    return super.validateItemEdit(item);
  }

  override validateItemDelete(item: any): string | undefined {
    if (this.notEditable.includes(item.measurement_type)) {
      return i18n._(msg`Auto-computed`);
    }

    return super.validateItemDelete(item);
  }
}
